/** The part of the day in India, for the greeting. Hours are read in IST whatever the device clock zone. */
export type DayPart = 'morning' | 'afternoon' | 'evening' | 'night';

export function dayPart(now: Date = new Date()): DayPart {
  const hour = Number(
    new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      hourCycle: 'h23',
      timeZone: 'Asia/Kolkata',
    }).format(now),
  );
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
}

/** The first word of a name, or null when there is none. */
export function firstName(name: string | null): string | null {
  const first = name?.trim().split(/\s+/)[0];
  return first === undefined || first === '' ? null : first;
}
